export default "__VITE_ASSET__xpW0RMhB__"